import React from 'react';
import PropTypes from 'prop-types';

/**
 * COMPONENTE: PersonalSurferMetricsRow
 * [HU-03] Barra horizontal de 10 KPIs de Telemetría y Embudo de Conversión en vivo.
 */
export const PersonalSurferMetricsRow = ({ metrics = {} }) => {
    const qrScans = metrics?.qrScansCount ?? 0;
    const pageViews = metrics?.pageViewsCount ?? 0;
    const formStarts = metrics?.formStartsCount ?? 0;
    const formCompletes = metrics?.formCompletesCount ?? 0;
    const gamesStarted = metrics?.gamesStartedCount ?? 0;
    const gamesCompleted = metrics?.gamesCompletedCount ?? 0;
    const bestRecord = metrics?.bestRecordScore ? `${metrics.bestRecordScore.toLocaleString('es-MX')} pts` : '—';
    const avgScore = metrics?.averageScore ? `${Math.round(metrics.averageScore).toLocaleString('es-MX')} pts` : '—';
    const totalHits = metrics?.totalHitsCount ?? 0;
    const successRate = metrics?.successRatePercentage !== undefined ? `${metrics.successRatePercentage.toFixed(1)}%` : '0.0%';

    const metricCards = [
        {
            id: 'qr_scan',
            title: 'Escaneos QR',
            value: qrScans.toLocaleString('es-MX'),
            subtitle: 'Lecturas de código',
            icon: 'bi-qr-code-scan',
            gradient: 'qr'
        },
        {
            id: 'page_view',
            title: 'Vistas Web',
            value: pageViews.toLocaleString('es-MX'),
            subtitle: 'Visitas móviles',
            icon: 'bi-eye-fill',
            gradient: 'page'
        },
        {
            id: 'form_start',
            title: 'Inicios Form.',
            value: formStarts.toLocaleString('es-MX'),
            subtitle: 'Comenzaron registro',
            icon: 'bi-pencil-square',
            gradient: 'start'
        },
        {
            id: 'form_complete',
            title: 'Forms. Completos',
            value: formCompletes.toLocaleString('es-MX'),
            subtitle: 'Leads listos',
            icon: 'bi-check2-circle',
            gradient: 'complete'
        },
        {
            id: 'game_start',
            title: 'Partidas Iniciadas',
            value: gamesStarted.toLocaleString('es-MX'),
            subtitle: 'Cuenta 3-2-1',
            icon: 'bi-play-circle-fill',
            gradient: 'game'
        },
        {
            id: 'game_complete',
            title: 'Partidas Fin.',
            value: gamesCompleted.toLocaleString('es-MX'),
            subtitle: 'Carreras procesadas',
            icon: 'bi-flag-fill',
            gradient: 'played'
        },
        {
            id: 'best_record',
            title: 'Mejor Récord',
            value: bestRecord,
            subtitle: 'Récord del estadio',
            icon: 'bi-trophy-fill',
            gradient: 'record'
        },
        {
            id: 'avg_score',
            title: 'Promedio Pts',
            value: avgScore,
            subtitle: 'Media global',
            icon: 'bi-speedometer2',
            gradient: 'avg'
        },
        {
            id: 'total_hits',
            title: 'Total Choques',
            value: totalHits.toLocaleString('es-MX'),
            subtitle: 'Obstáculos impactados',
            icon: 'bi-exclamation-triangle-fill',
            gradient: 'hits'
        },
        {
            id: 'success_rate',
            title: 'Tasa Éxito %',
            value: successRate,
            subtitle: 'Forms a Finalizadas',
            icon: 'bi-graph-up-arrow',
            gradient: 'rate'
        }
    ];

    return (
        <div className="personal-surfer-metrics-row">
            {metricCards.map((card) => (
                <div key={card.id} className={`metric-card card-${card.gradient}`}>
                    <div className="metric-header">
                        <span className="metric-title">{card.title}</span>
                        <i className={`bi ${card.icon} metric-icon`} />
                    </div>
                    <div className="metric-value">{card.value}</div>
                    <div className="metric-subtitle">{card.subtitle}</div>
                </div>
            ))}
        </div>
    );
};

PersonalSurferMetricsRow.propTypes = {
    metrics: PropTypes.shape({
        qrScansCount: PropTypes.number,
        pageViewsCount: PropTypes.number,
        formStartsCount: PropTypes.number,
        formCompletesCount: PropTypes.number,
        gamesStartedCount: PropTypes.number,
        gamesCompletedCount: PropTypes.number,
        bestRecordScore: PropTypes.number,
        averageScore: PropTypes.number,
        totalHitsCount: PropTypes.number,
        successRatePercentage: PropTypes.number
    })
};
